// Mirrors server/src/helpers/fleetEquipment/defectStatuses.js. A duplicate
// is closed without being fixed, but counts as completed everywhere.
export const DEFECT_STATUSES = [
  'New',
  'In Progress',
  'Waiting',
  'Completed',
  'Duplicate - Closed',
]
export const DEFECT_CLOSED_STATUSES = ['Completed', 'Duplicate - Closed']

export const isDefectClosed = (status) =>
  DEFECT_CLOSED_STATUSES.includes(status)

export const DEFECT_PRIORITIES = [
  { value: 1, label: 'Low' },
  { value: 2, label: 'Normal' },
  { value: 3, label: 'High' },
]
